// extracted by mini-css-extract-plugin
module.exports = {"main":"info_main__7Drgr","content":"info_content__EQiGj"};